import { customSeriesDefaultOptions, CustomSeriesOptions } from 'lightweight-charts'

export type HlcAreaSeriesOptions = CustomSeriesOptions & {
    highLineVisible: boolean,
    lowLineVisible: boolean,
    highLineColor: string,
    topFillColor: string,
    closeLineColor: string
    lowLineColor: string,
    bottomFillColor: string,
}

export const defaultOptions: HlcAreaSeriesOptions = {
    ...customSeriesDefaultOptions,
    highLineVisible: true,
    lowLineVisible: true,
    closeLineColor: '#2962ff',
    highLineColor: '#00bcd4',
    lowLineColor: '#e91e63',
    topFillColor: '#00bcd440',
    bottomFillColor: '#e91e6340',
}
